export default __webpack_public_path__ + "static/media/brand-01.1c981f98.png";